import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../../../AccessControl';
import { PERMISSIONS_KEY, PERMISSION_TYPE } from '../../../../common/constants';
import Error404 from '../../../../Error404';
import CreateStaff from './pages/CreateStaff';
import EditStaff from './pages/EditStaff';
import Staff from './pages/Staff';
import ViewStaff from './pages/ViewStaff';
import { LIBRARY_STAFF_BASE_PATH } from './staffConfig';

const permissionKey = PERMISSIONS_KEY?.SYSTEM_USERS_ADMINS;

const LibraryStaffWrapper = () => (
  <Switch>
    <Route
      exact
      path={LIBRARY_STAFF_BASE_PATH}
      render={(props) => (
        <AccessControl permissionKey={permissionKey}>
          <Staff {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${LIBRARY_STAFF_BASE_PATH}/add`}
      render={(props) => (
        <AccessControl
          permissionType={PERMISSION_TYPE?.CREATE}
          permissionKey={permissionKey}
        >
          <CreateStaff {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${LIBRARY_STAFF_BASE_PATH}/edit/:id`}
      render={(props) => (
        <AccessControl
          permissionType={PERMISSION_TYPE?.UPDATE}
          permissionKey={permissionKey}
        >
          <EditStaff {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${LIBRARY_STAFF_BASE_PATH}/view/:id`}
      render={(props) => (
        <AccessControl permissionKey={permissionKey}>
          <ViewStaff {...props} />
        </AccessControl>
      )}
    />
    <Route path="*" exact component={Error404} />
  </Switch>
);

export default LibraryStaffWrapper;
